<template>
  <!--- DÜZENLEME YAPMAYIN - GlobalSign SSL Site Mührü Kodu - DÜZENLEME YAPMAYIN --->
  <table
    width="125"
    border="0"
    cellspacing="0"
    cellpadding="0"
    title="DOĞRULAMA İÇİN TIKLAYIN: Bu site kişisel bilgilerinizin güvenliğini sağlamak için bir GlobalSign SSL Sertifikası kullanır."
  >
    <tbody>
      <tr>
        <td>
          <span id="ss_img_wrapper_gmogs_image_125-50_en_dblue"
            ><a
              href="https://www.globalsign.com.tr/"
              target="_blank"
              title="GlobalSign Site Mührü"
              rel="nofollow"
              ><img
                alt="SSL"
                border="0"
                id="ss_img"
                src="//seal.globalsign.com/SiteSeal/images/gs_noscript_125-50_en.gif" /></a
          ></span>
        </td>
      </tr>
    </tbody>
  </table>
  <!--- DÜZENLEME YAPMAYIN - GlobalSign SSL Site Mührü Kodu - DÜZENLEME YAPMAYIN --->
</template>

<script>
export default {
  mounted() {
    const plugin = document.createElement('script');
    plugin.setAttribute(
      'src',
      '//seal.globalsign.com/SiteSeal/gmogs_image_125-50_en_dblue.js',
    );
    plugin.async = true;
    document.head.appendChild(plugin);
  },
};
</script>
